import { render, staticRenderFns } from "./Procced.vue?vue&type=template&id=4232f461"
import script from "./Procced.vue?vue&type=script&lang=js"
export * from "./Procced.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports